import { CircleDollarSign } from "lucide-react";
import {
  formatEarningsCurrency,
  formatEarningsDate,
  normalizeEarningsStatus,
  statusLabel,
} from "../earningsAdapters";

export type LoyaltyReferralRow = {
  id: string;
  serialNo: number;
  date: string;
  partnerNetworkId: string;
  partnerNetworkName: string;
  receivedIncentive: number;
  grossAmount?: number;
  tdsPercentage?: number;
  tdsAmount?: number;
  netAmount?: number;
  tdsIsEstimated?: boolean;
  status: string;
};

const renderStatus = (status: string) => (
  <span
    className={`loyalty-referral-status loyalty-referral-status-${normalizeEarningsStatus(status)}`}
  >
    {statusLabel(status)}
  </span>
);

const LoyaltyReferralTable = ({ rows }: { rows: LoyaltyReferralRow[] }) => (
  <div className="loyalty-referral-table-card">
    <div className="loyalty-referral-mobile-scroll-hint">
      Swipe horizontally to view all columns
    </div>
    <div className="loyalty-referral-table-scroll">
      <table className="loyalty-referral-table">
        <thead>
          <tr>
            <th>S.NO</th>
            <th>DATE</th>
            <th>PARTNER NETWORK ID</th>
            <th>PARTNER NETWORK NAME</th>
            <th>RECEIVED INCENTIVES</th>
            <th>TDS</th>
            <th>NET AMOUNT</th>
            <th>STATUS</th>
          </tr>
        </thead>
        <tbody>
          {rows.length > 0 ? (
            rows.map((record) => (
              <tr key={record.id}>
                <td className="loyalty-referral-serial-cell">
                  <span className="loyalty-referral-mobile-label">S.NO</span>
                  <strong>{record.serialNo}</strong>
                </td>
                <td>
                  <span className="loyalty-referral-mobile-label">DATE</span>
                  <strong className="loyalty-referral-date-value">
                    {formatEarningsDate(record.date)}
                  </strong>
                </td>
                <td>
                  <span className="loyalty-referral-mobile-label">
                    PARTNER NETWORK ID
                  </span>
                  <strong className="loyalty-referral-id-value">
                    {record.partnerNetworkId}
                  </strong>
                </td>
                <td>
                  <span className="loyalty-referral-mobile-label">
                    PARTNER NETWORK NAME
                  </span>
                  <div className="loyalty-referral-name">
                    <span>
                      {record.partnerNetworkName.charAt(0).toUpperCase()}
                    </span>
                    <strong>{record.partnerNetworkName}</strong>
                  </div>
                </td>
                <td>
                  <span className="loyalty-referral-mobile-label">
                    RECEIVED INCENTIVES
                  </span>
                  <div className="loyalty-referral-amount">
                    <CircleDollarSign size={17} strokeWidth={2} />
                    <strong>
                      {formatEarningsCurrency(record.grossAmount ?? record.receivedIncentive)}
                    </strong>
                  </div>
                </td>
                <td>
                  <span className="loyalty-referral-mobile-label">TDS</span>
                  <strong>
                    {record.tdsAmount != null
                      ? `${formatEarningsCurrency(record.tdsAmount)}${record.tdsIsEstimated ? " (est)" : ""}`
                      : "—"}
                  </strong>
                </td>
                <td>
                  <span className="loyalty-referral-mobile-label">
                    NET AMOUNT
                  </span>
                  <strong>
                    {formatEarningsCurrency(record.netAmount ?? record.receivedIncentive)}
                  </strong>
                </td>
                <td className="loyalty-referral-status-cell">
                  <span className="loyalty-referral-mobile-label">STATUS</span>
                  {renderStatus(record.status)}
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td className="loyalty-referral-empty" colSpan={8}>
                No loyalty referral incentive records found.
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  </div>
);

export default LoyaltyReferralTable;
